import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, FormControl, ReactiveFormsModule, Validators} from "@angular/forms";
import {
    FormLabelComponent
} from "../../../common/forms/form-label/form-label.component";
import {
    FormEmailInputComponent
} from "../../../common/forms/form-email-input/form-email-input.component";
import {
    FormButtonComponent
} from "../../../common/forms/form-button/form-button.component";
import {
    AppAlertService,
    ParametersService,
    SettingsAccountService,
    SubtitlesService
} from "../../../core";
import {
    FormActionButtonsComponent
} from "../../../common/forms/form-action-buttons/form-action-btns.component";

@Component({
  selector: 'email-form',
  standalone: true,
    imports: [
        ReactiveFormsModule,
        FormLabelComponent,
        FormEmailInputComponent,
        FormButtonComponent,
        FormActionButtonsComponent
    ],
  templateUrl: './email-form.component.html',
  styleUrl: './email-form.component.scss'
})
export class EmailFormComponent implements OnInit {
    @Output() close = new EventEmitter();
    emailForm: FormGroup;

    constructor(
        private appAlert: AppAlertService,
        private fb: FormBuilder,
        private parameters: ParametersService,
        private settingsAccount: SettingsAccountService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngOnInit(): void {
        this.emailForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]]
        });
        this.emailForm.patchValue({email: this.settingsAccount.accountInformation.accountEmail});
    }

    get emailControl() {
        return this.emailForm.get('email') as FormControl;
    }

    closeForm(): void {
        this.close.emit();
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    changeAccountEmail(): void {
        if (this.parameters.demoAccount()) {
            this.appAlert.openDemoAccountDialog();
            return;
        }

        if (this.emailForm.valid) {
            this.settingsAccount.newAccountEmail = this.emailForm.value.email;
            this.settingsAccount.changeAccountEmail()
            this.closeForm();
        } else {
            this.emailForm.markAllAsTouched();
        }
    }
}
